module.exports = __webpack_public_path__ + "a70391af68fcf8f8b431fb3e5b258d39.jpg";